export default __webpack_public_path__ + "static/media/companies-forbes.17b0eb7c.svg";